export default __webpack_public_path__ + "static/media/CreedBratton.a67bd2e5.jpg";